const app_id = window.location.host.split('.')[1] ? window.location.host.split('.')[0] : "staging";
export const Target = {
    app_id: app_id,
    js_key: "jsid",
    server: process.env.VUE_APP_SERVER_URL ? process.env.VUE_APP_SERVER_URL : `https://${app_id}.playmas-api.com/`,
    desc: "Playmas Storefront",
};
